import { Wrench } from "@procore/core-icons";
import { useCallback, useEffect } from "react";

import type { ToolbarButtonEntry } from "contexts/toolbars";
import { toolbarsActions, useDispatchToolbars } from "contexts/toolbars";
import { DEBUG_UTILS_WINDOW_ID, useDispatchWindows, useWindows, windowsActions } from "contexts/windows";

import { Toolbar } from "../Toolbar";

/** @param props.id Toolbar id. Defaults to `"debug-utils-toolbar"`. */
export function DebugUtilsToolbar({ id = "debug-utils-toolbar" }: { id?: string }) {
    const debugUtilsWindow = useWindows()[DEBUG_UTILS_WINDOW_ID];
    const toolbarDispatch = useDispatchToolbars();
    const dispatchWindows = useDispatchWindows();

    const handleClick = useCallback(() => {
        dispatchWindows(windowsActions.toggleWindow(DEBUG_UTILS_WINDOW_ID, { elementId: id, placement: "right" }));
    }, [dispatchWindows, id]);

    useEffect(() => {
        const buttons: ToolbarButtonEntry[] = [
            {
                config: {
                    id: "debugUtils",
                    icon: <Wrench />,
                    onClick: handleClick,
                    tooltip: {
                        toolName: "debugUtils",
                        label: "Debug utils",
                        shortcutKey: "",
                        alwaysVisible: false,
                        placement: "right",
                    },
                },
                state: {
                    active: false,
                    disabled: false,
                    visible: true,
                },
            },
        ];
        toolbarDispatch(toolbarsActions.addToolbar({ id, buttons }));

        return () => {
            toolbarDispatch(toolbarsActions.removeToolbar(id));
        };
    }, [toolbarDispatch, id, handleClick]);

    useEffect(() => {
        toolbarDispatch(
            toolbarsActions.updateButtonState(id, "debugUtils", {
                active: debugUtilsWindow?.state.open ?? false,
            }),
        );
    }, [toolbarDispatch, id, debugUtilsWindow?.state.open]);

    return <Toolbar id={id} />;
}
